"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _isOnServer = _interopRequireDefault(require("./isOnServer"));

var _constants = require("./constants");

/**
 * Checks for a log level override defined as a cookie.
 * This will only  affect client-side logging,
 * as we don't currently pass server-request when initializing this library
 */
var getCookieOverride = function getCookieOverride() {
  if ((0, _isOnServer.default)()) return undefined;

  var overrideCookie = _jsCookie.default.get('nw-log-level');

  if (!overrideCookie) return undefined;
  if (!_constants.LevelPriority[overrideCookie]) return undefined;
  return overrideCookie;
};

var _default = getCookieOverride;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXRDb29raWVPdmVycmlkZS50cyJdLCJuYW1lcyI6WyJnZXRDb29raWVPdmVycmlkZSIsInVuZGVmaW5lZCIsIm92ZXJyaWRlQ29va2llIiwiQ29va2llcyIsImdldCIsIkxldmVsUHJpb3JpdHkiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSxJQUFNQSxpQkFBaUIsR0FBRyxTQUFwQkEsaUJBQW9CLEdBQXlCO0FBQ2pELE1BQUksMEJBQUosRUFBa0IsT0FBT0MsU0FBUDs7QUFFbEIsTUFBTUMsY0FBYyxHQUFHQyxrQkFBUUMsR0FBUixDQUFZLGNBQVosQ0FBdkI7O0FBQ0EsTUFBSSxDQUFDRixjQUFMLEVBQXFCLE9BQU9ELFNBQVA7QUFFckIsTUFBSSxDQUFDSSx5QkFBY0gsY0FBZCxDQUFMLEVBQTZDLE9BQU9ELFNBQVA7QUFFN0MsU0FBT0MsY0FBUDtBQUNELENBVEQ7O2VBV2VGLGlCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvb2tpZXMgZnJvbSAnanMtY29va2llJztcbmltcG9ydCBpc09uU2VydmVyIGZyb20gJy4vaXNPblNlcnZlcic7XG5pbXBvcnQgeyBMZXZlbCwgTGV2ZWxQcmlvcml0eSB9IGZyb20gJy4vY29uc3RhbnRzJztcbi8qKlxuICogQ2hlY2tzIGZvciBhIGxvZyBsZXZlbCBvdmVycmlkZSBkZWZpbmVkIGFzIGEgY29va2llLlxuICogVGhpcyB3aWxsIG9ubHkgIGFmZmVjdCBjbGllbnQtc2lkZSBsb2dnaW5nLFxuICogYXMgd2UgZG9uJ3QgY3VycmVudGx5IHBhc3Mgc2VydmVyLXJlcXVlc3Qgd2hlbiBpbml0aWFsaXppbmcgdGhpcyBsaWJyYXJ5XG4gKi9cbmNvbnN0IGdldENvb2tpZU92ZXJyaWRlID0gKCk6IExldmVsIHwgdW5kZWZpbmVkID0+IHtcbiAgaWYgKGlzT25TZXJ2ZXIoKSkgcmV0dXJuIHVuZGVmaW5lZDtcblxuICBjb25zdCBvdmVycmlkZUNvb2tpZSA9IENvb2tpZXMuZ2V0KCdudy1sb2ctbGV2ZWwnKTtcbiAgaWYgKCFvdmVycmlkZUNvb2tpZSkgcmV0dXJuIHVuZGVmaW5lZDtcblxuICBpZiAoIUxldmVsUHJpb3JpdHlbb3ZlcnJpZGVDb29raWUgYXMgTGV2ZWxdKSByZXR1cm4gdW5kZWZpbmVkO1xuXG4gIHJldHVybiBvdmVycmlkZUNvb2tpZSBhcyBMZXZlbDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGdldENvb2tpZU92ZXJyaWRlO1xuIl19